/* eslint-disable */
import store from '../store.js'
import * as d3 from 'd3'
import d3SelectionMulti from 'd3-selection-multi'

import Knoten from './Knoten'
import Gelenk from './Gelenk'
import Stab from './Stab'
import Stablast from './Stablast'
import Knotenlast from './Knotenlast'


function getMax(arr){
    return Math.max(...arr.map(e => Array.isArray(e) ? getMax(e) : e))
}

function getMin(arr){
    return Math.min(...arr.map(e => Array.isArray(e) ? getMin(e) : e))
}

const DRAW_BELASTUNG = 1
const DRAW_AUFLAGERREAKT = 2
const DRAW_ERGEBNISSE = 3
const DRAW_BEMAßUNG = 4

const DRAW_NORMALKRAFT = 1
const DRAW_QUERKRAFT = 2
const DRAW_MOMENT = 3
const DRAW_VERFORMUNG = 4

const SCHNITTKRAFTGRÖßE = 80

const KNOTENGRÖßE = 4
const KNOTENFARBE = 'red'
const AUFLAGERGRÖßE = 20
const AUFLAGERFÜLLFARBE = 'grey'
const GELENKGRÖßE = 3
const STABSTRICHSTÄRKE = 3
const FACHWERKSTABSTRICHSTÄRKE = 1.5
const STABSTRICHFARBE = 'black'
const FASERABSTAND = 6
const FASERSTRICHSTÄRKE = 1.5

const RAND = 120 //80

const KNOTENLASTGRÖßE = 40
const KNOTENLASTSTRICHSTÄRKE = 3

const AUFLAGERREAKTIONGRÖßE = 40
const AUFLAGERREAKTIONSTRICHSTÄRKE = 3
const AUFLAGERREAKTIONFARBE = 'blue'

const STABLASTGRÖßE = 40
const STABLASTSTRICHSTÄRKE = 1
//const STABLASTSCHRIFTGRÖßE = 8
//const STABLASTKOMMASTELLEN = 2
const STABLASTPFEILABSTAND = 40
const STABLASTOFSETY = 10

const SPIRALPATH = "M 0 0  C 0.043 0 0.082 -0.035 0.088 -0.088  C 0.095 -0.145 0.064 -0.209 0 -0.25  C -0.07 -0.295 -0.169 -0.304 -0.265 -0.265  C -0.371 -0.222 -0.459 -0.127 -0.5 0  C -0.544 0.139 -0.526 0.3 -0.442 0.442  C -0.351 0.595 -0.192 0.709 0 0.75  C 0.206 0.794 0.431 0.749 0.619 0.619  C 0.819 0.48 0.959 0.258 1 0  C 1.043 -0.273 0.972 -0.561 0.795 -0.795  C 0.61 -1.043 0.324 -1.209 0 -1.25  C -0.339 -1.293 -0.691 -1.195 -0.972 -0.972  C -1.266 -0.739 -1.459 -0.390 -1.5 0  M -2 0  H -1"

// This variable will be used later for move events to check if pointer is down or not
var isPointerDown = false;

// This variable will contain the original coordinates when the user start pressing the mouse or touching the screen
var pointerOrigin = [0,0];

// The distances calculated from the pointer will be stored here
var viewBox ={x: 0,y: 0,width: 800,height: 500};
var newViewBox = {x: 0,y: 0};
var oldRatio = 1;
var ratio = 1;


export default class StatikCanvas{
    constructor(svgElement,width, height){
        this.canvas = svgElement
        this.width = width || svgElement.node().getBoundingClientRect().width
        this.height = height || svgElement.node().getBoundingClientRect().height
        viewBox = {x: 0,y: 0,width: this.width,height: this.height};
        ratio = this.width / svgElement.node().getBoundingClientRect().width
        this.init()
        this.MaßstabX = null
        this.MaßstabY = null
        this.DRAW_STABNUMMER = false 
        this.resultSettings = {
            LängenEinheit: {name: 'm', value: 1},
            KraftEinheit: {name: 'kN', value: 1000}
        }        
    }

    zoomend(){
        d3.event.transform.x = 0
        d3.event.transform.y = 0
    }

    zoomed(){
        let t = d3.event.transform;
        let oViewBox = this.attributes.viewBox.value.split(',').map(d => +d)
        let p  = {x: t.x, y: t.y}
        t.x = oViewBox[0]-t.x
        t.y = oViewBox[1]-t.y
        if(t.k === 1) t.x = t.y = 0;

        const width=this.attributes.width.value
        const height=this.attributes.height.value

        var newViewBox = [t.x,t.y, width/t.k, height/t.k].join(",");
        this.attributes.viewBox.value = newViewBox
    }

    init(){
        this.canvas.attrs({width: this.width, height: this.height, class: 'chart', viewBox: [0,0,this.width,this.height], overflow: 'auto'})
        let defs = this.canvas.append('defs')
        // Schrägstriche für feste Auflager
        let pattern = defs.append('pattern')
            .attrs({id:'Schrägstriche',
                    width:'1.1',
                    height:'1.5'});

        pattern.append('line').attrs({x1:'0', y1:'8', x2:'5', y2:'-1', stroke:'black'});
        pattern.append('line').attrs({x1:'7', y1:'8', x2:'12', y2:'-1', stroke:'black'});
        pattern.append('line').attrs({x1:'14', y1:'8', x2:'19', y2:'-1', stroke:'black'});
        
        let ColorGrad = defs.append('linearGradient').attrs({
                id:'SchnittkraftFarbe',
                gradientUnits: 'userSpaceOnUse',
                x2: '0', y2: '0.5'})
            ColorGrad.append('stop').attrs({
                offset:'50%',
                'stop-color': 'red'})
            ColorGrad.append('stop').attrs({
                offset:'50%',
                'stop-color': 'blue'})


        let zoom = d3.zoom()
        .scaleExtent([1,20])
        // .translateExtent([[0, 0],[this.width, this.height]])
        .on("zoom", this.zoomed)
        .on("end", this.zoomend)
        .on("start", this.zoomstart);
        this.canvas.call(zoom)
        // this.drawBorder()

        // ---Canvassteuerung noch nicht fertig---
        // im Folgenden werden die Events zum verschieben der Zeichenfläche definiert
        // window.addEventListener('resize', function() {
        // this.ratio = this.viewBox.width / this.canvas.getBoundingClientRect().width;
        // })
        // if (window.PointerEvent) {
        //     this.canvas.on('pointerdown', this.onPointerDown) // Pointer is pressed
        //     .on('pointerup', this.onPointerUp) // Releasing the pointer
        //     .on('pointerleave', this.onPointerUp) // Pointer gets out of the SVG area
        //     .on('pointermove', this.onPointerMove); // Pointer is moving
        //     } else {
        //     // Add all mouse events listeners fallback
        //     this.canvas.on('mousedown', this.onPointerDown) // Pressing the mouse
        //     .on('mouseup', this.onPointerUp) // Releasing the mouse
        //     .on('mouseleave', this.onPointerUp) // Mouse gets out of the SVG area
        //     .on('mousemove', this.onPointerMove) // Mouse is moving
        
        //     // Add all touch events listeners fallback
        //     .on('touchstart', this.onPointerDown) // Finger is touching the screen
        //     .on('touchend', this.onPointerUp) // Finger is no longer touching the screen
        //     .on('touchmove', this.onPointerMove); // Finger is moving
        //     }
    }

// ---Canvassteuerung noch nicht fertig---
// im Folgenden wird die Steuerung zum Verschieben der Zeichnung definiert
// derzeit noch etwas ruppig
//     // Function called by the event listeners when user start pressing/touching
//     onPointerDown() {
//         isPointerDown = true; 
//         pointerOrigin = d3.mouse(this)
//     }

//     // Function called by the event listeners when user start moving/dragging
//    onPointerMove() {
//         // Only run this function if the pointer is down
//         if (!isPointerDown) {
//             return;
//         }
//         d3.event.preventDefault();

//         // Get the pointer position
//         var pointerPosition = d3.mouse(this);

//         // We calculate the distance between the pointer origin and the current position
//         // The viewBox x & y values must be calculated from the original values and the distances
//         newViewBox.x = viewBox.x - ((pointerPosition[0] - pointerOrigin[0]) * ratio);
//         newViewBox.y = viewBox.y - ((pointerPosition[1] - pointerOrigin[1]) * ratio);

//         // We create a string with the new viewBox values
//         // The X & Y values are equal to the current viewBox minus the calculated distances
//         var viewBoxString = `${newViewBox.x} ${newViewBox.y} ${viewBox.width} ${viewBox.height}`;
//         // We apply the new viewBox values onto the SVG
//         d3.select(this).attr('viewBox', viewBoxString);
//     }

//     onPointerUp(){
//         if (isPointerDown){
//             isPointerDown = false;
//             viewBox.x = newViewBox.x;
//             viewBox.y = newViewBox.y;
//         }
//     }



    
    clear(){
        this.canvas.selectAll('svg > #Achsen, #Knoten, #Stäbe, #Belastung, #Auflagerreaktionen, #Schnittkräfte').remove();
    }

    drawPfeil(Gruppe, Größe, Winkel, translate){
        return Gruppe.append('polygon')
            .attrs({'points': [-Größe,0, -Größe/6,0, -Größe/6,-Größe/12, 0,0, -Größe/6,Größe/12, -Größe/6,0],
                    'transform': 'rotate('+Winkel+',0,0) translate('+ translate.x + ',' + translate.y +')'  
            });
    }

    drawPfeilBeschriftung(gruppe, string, winkel, translate, align){
        let textSVG = gruppe.append('text')
        .text(string)
        .attrs({'font-family':'Calibri',
                'font-size':'12px',
                'font-weight': 'bold',
                'stroke': 'none',
                'text-anchor': align? align: "end",
                'dy': '-0.5ex'
            })

        let transformString = ''
        if (winkel >=45 && winkel <= 225){
            let textDx = 0 // textSVG._groups[0][0].getBBox().width
            transformString = 'rotate('+winkel+') translate('+(-textDx+translate.x)+','+translate.y+') scale(-1,-1)'
        } else {
            let textDx = 0 //textSVG._groups[0][0].getBBox().width
            transformString = 'rotate('+winkel+') translate('+ (-textDx+translate.x)+','+translate.y+')'
        }
        textSVG.attr('transform', transformString)
        return textSVG
    }

    drawMomentenPfeil(Gruppe, Größe, richtung,  translate){
        let PfeilSVG = Gruppe.append('g')
        .attr('transform', 'scale('+richtung+',1) translate('+ translate.x + ',' + translate.y +')')

        let arc = d3.arc()
        .innerRadius(Größe/1.5)
        .outerRadius(Größe/1.5)
        .startAngle(-Math.PI/2)
        .endAngle(Math.PI/2.5);

        PfeilSVG.append('path')
                .attrs({'d': arc,
                    'transform': 'rotate(0,0,0)'});

        PfeilSVG.append('polygon')
                .attrs({'points': [-AUFLAGERREAKTIONGRÖßE/6,-AUFLAGERREAKTIONGRÖßE/12,
                                    0,0,
                                    -AUFLAGERREAKTIONGRÖßE/6,AUFLAGERREAKTIONGRÖßE/12],
                        'transform': 'rotate(-18) translate('+AUFLAGERREAKTIONGRÖßE/1.5+','+AUFLAGERREAKTIONGRÖßE/6+') rotate(90)'
                })
        return PfeilSVG
    }

    drawBorder(){
        this.canvas.append('rect')
        .attrs({
            x: 1,
            y: 1,
            width: this.width-2, 
            height: this.height-2,
            id: 'Border'})
        .styles({
            fill: 'none',
            stroke: 'black',
            'stroke-width': '2px'
        });
    }

    /**
     * 
     * @param {d3Selection} Gruppe 
     * @param {Stab} stab 
     */
    drawStab(Gruppe, stab){
        const strichstärke = stab.isFachwerkstab ? FACHWERKSTABSTRICHSTÄRKE : STABSTRICHSTÄRKE
        let strich = Gruppe.append('g')
            .attrs({
                'stroke': STABSTRICHFARBE,
                'stroke-width': strichstärke,
                'id': 'Stab_'+stab.number})
            .on('contextmenu dblclick', function(){
                d3.event.preventDefault();
                store.commit('editStab',stab)
            })
            .on('click', function(e) {
                store.commit('selectStab',stab)
            });

        strich.append('line')
            .attrs({ 
                'x1': this.MaßstabX(stab.StartKnoten.x),
                'y1':  this.MaßstabY(stab.StartKnoten.y),
                'x2': this.MaßstabX(stab.EndKnoten.x),
                'y2':  this.MaßstabY(stab.EndKnoten.y),
                'vector-effect': 'non-scaling-stroke',
            })
            .on('mouseover', function(){
                d3.select(this).attr('stroke-width',strichstärke*1.5)
            })
            .on('mouseout', function(){
                d3.select(this).attr('stroke-width',null)    
            });

        const ts = stab.tsin
        const tc = stab.tcos
        
        if(!stab.isFachwerkstab){
        // Faserlinie zeichnen
            strich.append('line')
                .attrs({   
                    'x1': this.MaßstabX(stab.StartKnoten.x),
                    'y1':  this.MaßstabY(stab.StartKnoten.y),
                    'x2': this.MaßstabX(stab.EndKnoten.x),
                    'y2':  this.MaßstabY(stab.EndKnoten.y),
                    'stroke-width': FASERSTRICHSTÄRKE,
                    'stroke-dasharray':'5,5',
                    'transform': 'translate('+ FASERABSTAND * ts +','+ FASERABSTAND * tc +')'});
        } 
        if (stab.StartGelenk) this.drawGelenk(strich, stab.StartGelenk, stab, 0)
        if (stab.EndGelenk) this.drawGelenk(strich, stab.EndGelenk, stab, 1)

        if (this.DRAW_STABNUMMER) {
        // Stabnummer zeichnen
            const transformString = 'translate('+this.MaßstabX(stab.center.x)+','+ this.MaßstabY(stab.center.y)+') rotate('+ -stab.vector.direction_deg+')'
            let text = strich.append('text')
                .text(stab.name)
                .attrs({'font-family':'Calibri',
                    'font-size':'12px',
                    'stroke': 'none',
                    'dy': '-0.5ex',
                    'transform': transformString});
            text.attr('dx', -text._groups[0][0].getBBox().width/2)
        }
        stab.d3Node = strich
    }

    /**
     * 
     * @param {d3Selection} Gruppe 
     * @param {Gelenk} gelenk 
     * @param {Stab} stab 
     * @param {*} position 
     */
    drawGelenk(Gruppe, gelenk, stab, position){
        const ts = stab.tsin
        const tc = stab.tcos
        let transformString = ''

        if(position === 0) transformString = 'translate('+ 2*GELENKGRÖßE*tc +','+ -2*GELENKGRÖßE*ts +')'
        else transformString = 'translate('+ -2*GELENKGRÖßE*tc +','+ 2*GELENKGRÖßE*ts +')'
        // Gelenk zeichnen
        Gruppe.append('circle')
            .attrs({
                'cx': this.MaßstabX(stab.Knoten[position].x),
                'cy':  this.MaßstabY(stab.Knoten[position].y),
                'r': GELENKGRÖßE,
                'fill': 'white',
                // 'fill-opacity': 1,
                'stroke': 'black',
                'stroke-width': 1,
                'transform': transformString}); 
    }

    /**
     * 
     * @param {d3Selection} Gruppe 
     * @param {Knoten} knoten 
     */
    drawKnoten(Gruppe, knoten){ 
        if (knoten.Auflager) {
            this.drawAuflager(Gruppe, knoten, knoten.Auflager)
        }
        let circle = Gruppe.append('circle')
            .attrs({'cx': this.MaßstabX(knoten.x),
                'cy':  this.MaßstabY(knoten.y),
                'r': KNOTENGRÖßE,
                'class': 'Knoten',
                'id': 'Knoten_'+knoten.number,
                'fill': KNOTENFARBE,})
            .on('mouseover', function() {
                circle.attr('r',KNOTENGRÖßE*1.2)
            })
            .on('mouseout', function(){
                circle.attr('r',KNOTENGRÖßE)
            })
            .on('contextmenu dblclick', function(e) {
                d3.event.preventDefault()
                store.commit('editKnoten',knoten)
            })
            .on('click', function(e) {
                store.commit('selectKnoten',knoten)
            });
        knoten.d3Node = circle
    }

    drawFedersteifigkeit(Gruppe, transformString){
        //Polygon zeichnen
        // let polyPoints = [0,0, AUFLAGERGRÖßE/6,0, AUFLAGERGRÖßE/3,AUFLAGERGRÖßE/2, AUFLAGERGRÖßE/2,-AUFLAGERGRÖßE/2, AUFLAGERGRÖßE*4/6,0, AUFLAGERGRÖßE,0, AUFLAGERGRÖßE,AUFLAGERGRÖßE/2, AUFLAGERGRÖßE,-AUFLAGERGRÖßE/2]
        let polyPoints = [0,0, 0,AUFLAGERGRÖßE/6, -AUFLAGERGRÖßE/2,AUFLAGERGRÖßE/3, AUFLAGERGRÖßE/2,AUFLAGERGRÖßE/2, 0,AUFLAGERGRÖßE*4/6, 0,AUFLAGERGRÖßE, -AUFLAGERGRÖßE/2,AUFLAGERGRÖßE, AUFLAGERGRÖßE/2,AUFLAGERGRÖßE]
        
        Gruppe.append('polyline').attrs({
                points: polyPoints,
                fill: 'none',
                stroke: 'black',
                transform: transformString,
            });
    }

    drawAuflagerStrich(Gruppe,transformString){
        Gruppe.append('line')
        .attrs({
            x1: 0,
            y1: AUFLAGERGRÖßE*0.9,
            x2: AUFLAGERGRÖßE,
            y2: AUFLAGERGRÖßE*0.9,
            stroke: 'black',
            transform: transformString});
    }

    drawAuflagerFest(Gruppe, transformString){
        Gruppe.append('rect')
        .attrs({
            x:0,
            y:AUFLAGERGRÖßE*0.75,
            fill:'url(#Schrägstriche)',
            width:AUFLAGERGRÖßE,
            height:'6',
            transform: transformString});
    }

    drawAuflagerEinspannung(Gruppe, transformString){
        let Quadrat = Gruppe.append('rect')
        .attrs({            
            x: 0,
            y: 0,
            width: AUFLAGERGRÖßE, 
            height: AUFLAGERGRÖßE,
            stroke: 'black',
            'stroke-width': '2',
            fill: AUFLAGERFÜLLFARBE,
            'fill-opacity': 0.5,
            transform: 'translate(0,'+ -AUFLAGERGRÖßE/2 +')'});
        return Quadrat            
    }

    drawDrehfeder(Gruppe, transformString){
        let Spirale = Gruppe.append('path')
        .attrs({
            d: SPIRALPATH,
            fill: 'none',
            stroke: '#000000',
            "stroke-width":"0.05",
            transform: 'translate('+(AUFLAGERGRÖßE/2)+' 0) scale('+AUFLAGERGRÖßE*2/3+','+AUFLAGERGRÖßE*2/3+')'
        })
        return Spirale
        // <path xmlns="http://www.w3.org/2000/svg" style="fill:none; stroke:#ff0000; stroke-width:0.03;" d="  "/>
    }

    drawAuflagerDreieck(Gruppe, transformString){
        const AuflagerDreieckPunkte = [0, AUFLAGERGRÖßE*0.75, AUFLAGERGRÖßE/2, 0, AUFLAGERGRÖßE, AUFLAGERGRÖßE*0.75]
        let Dreieck = Gruppe.append('polygon')
            .attrs({'points': AuflagerDreieckPunkte,
                'stroke': 'black',
                'fill': AUFLAGERFÜLLFARBE,
                'fill-opacity': 0.5});
        return Dreieck
    }

    drawAuflager(Gruppe, knoten, auflager){
        const transformString = 'translate('+ (this.MaßstabX(knoten.x)-AUFLAGERGRÖßE/2) +','+ this.MaßstabY(knoten.y) +') rotate('+ -auflager.Winkel_Degree+','+AUFLAGERGRÖßE/2+','+0+')'
        let auflagerGr = Gruppe.append('g')
            .attr('transform', transformString);

        if (auflager.Werte[0] == 0 && auflager.Werte[1] == 0 && auflager.Werte[2] == 0) {
            return console.log('Auflager hat keine Festhaltung.')
        }
        // Testen ob Auflager eine Einspannung hat
        switch(auflager.Werte[2]){
            // Auflager ohne Einspannung = Dreieck
            case 0: 
                if ((auflager.Werte[0] == 0 && auflager.Werte[1] == 0)) break  // nichts zeichnen da keine Festhaltung vorhanden ist, auch keine Einspannung

                let Dreieck = undefined

                //x-Richtung Fest
                if (auflager.Werte[0] == -1 && auflager.Werte[1] == -1){ //X und Y Fest
                    Dreieck = this.drawAuflagerDreieck(auflagerGr)
                    this.drawAuflagerFest(auflagerGr)
                }
                else if (auflager.Werte[0] == -1 && auflager.Werte[1] == 0){ //X fest Y frei
                    Dreieck = this.drawAuflagerDreieck(auflagerGr)
                    Dreieck.attr('transform', 'rotate(-90,'+ AUFLAGERGRÖßE/2 +',0)') //Dreieck auf die Seite drehen    
                    this.drawAuflagerStrich(auflagerGr, 'rotate(-90,'+AUFLAGERGRÖßE/2+',0)'); // Strich der die verschieblichkeit in vertikaler Richtung signalisiert
                }
                else if (auflager.Werte[0] == -1 && auflager.Werte[1] > 0){ //X fest Y Feder
                    Dreieck = this.drawAuflagerDreieck(auflagerGr)
                    Dreieck.attr('transform', 'rotate(-90,'+ AUFLAGERGRÖßE/2 +',0)') //Dreieck auf die Seite drehen  
                    this.drawAuflagerStrich(auflagerGr, 'rotate(-90,'+AUFLAGERGRÖßE/2+',0)'); // Strich der die verschieblichkeit in vertikaler Richtung signalisiert
                    this.drawFedersteifigkeit(auflagerGr,'translate('+AUFLAGERGRÖßE/2+','+AUFLAGERGRÖßE/6+')')
                }
                //x-Richtung Frei
                else if(auflager.Werte[0] == 0 && auflager.Werte[1] == -1){ //X frei Y fest
                    Dreieck = this.drawAuflagerDreieck(auflagerGr)
                    this.drawAuflagerStrich(auflagerGr)
                } 
                else if(auflager.Werte[0] == 0 && auflager.Werte[1] == 0){ // X frei Y frei
                    // nichts zeichnen da keine Festhaltung vorhanden ist, auch keine Einspannung
                }
                else if (auflager.Werte[0] == 0 && auflager.Werte[1] > 0) { // X frei Y Feder
                    this.drawFedersteifigkeit(auflagerGr,'translate('+AUFLAGERGRÖßE/2+','+AUFLAGERGRÖßE/6+')')
                    this.drawAuflagerStrich(auflagerGr, 'translate(0,'+(AUFLAGERGRÖßE/2)+')')
                } 
                //x-Richtung Feder
                else if(auflager.Werte[0] > 0 && auflager.Werte[1] == -1){ // X Feder Y fest
                    Dreieck = this.drawAuflagerDreieck(auflagerGr)
                    this.drawAuflagerStrich(auflagerGr)
                    this.drawFedersteifigkeit(auflagerGr,'rotate(-90) translate(0,'+AUFLAGERGRÖßE*2/3+')')
                }
                //x-Richtung und Y-Richtung Feder
                else if(auflager.Werte[0] > 0 && auflager.Werte[1] > 0){
                    this.drawFedersteifigkeit(auflagerGr,'rotate(-90) translate(0,'+AUFLAGERGRÖßE*2/3+')')
                    this.drawFedersteifigkeit(auflagerGr,'translate('+AUFLAGERGRÖßE/2+','+AUFLAGERGRÖßE/6+')')
                }
            break
            // Auflager mit Einspannung oder Drehfeder
            default:
                this.drawAuflagerEinspannung(auflagerGr)  
                
                // Wenn eine Drehfeder vorhanden ist. 
                if (auflager.Werte[2] > 0) this.drawDrehfeder(auflagerGr)

                //x-Richtung Fest
                if (auflager.Werte[0] == -1 && auflager.Werte[1] == -1){
                    this.drawAuflagerFest(auflagerGr)
                    this.drawAuflagerFest(auflagerGr,'rotate(-90,'+AUFLAGERGRÖßE/2+',0)')
                }
                else if (auflager.Werte[0] == -1 && auflager.Werte[1] == 0){
                    this.drawAuflagerFest(auflagerGr)
                    this.drawAuflagerStrich(auflagerGr, 'rotate(-90,'+AUFLAGERGRÖßE/2+',0)');
                }
                else if (auflager.Werte[0] == -1 && auflager.Werte[1] > 0){
                    this.drawFedersteifigkeit(auflagerGr,'translate('+AUFLAGERGRÖßE/2+','+AUFLAGERGRÖßE/2+')')
                    this.drawAuflagerFest(auflagerGr, 'translate (0,'+AUFLAGERGRÖßE+')')
                }
                //x-Richtung Frei
                else if(auflager.Werte[0] == 0 && auflager.Werte[1] == -1){
                    this.drawAuflagerStrich(auflagerGr)
                    this.drawAuflagerFest(auflagerGr,'rotate(-90,'+AUFLAGERGRÖßE/2+',0)')
                } 
                else if(auflager.Werte[0] == 0 && auflager.Werte[1] == 0){
                    this.drawAuflagerStrich(auflagerGr)
                    this.drawAuflagerStrich(auflagerGr, 'rotate(-90,'+AUFLAGERGRÖßE/2+',0)');
                }
                else if (auflager.Werte[0] == 0 && auflager.Werte[1] > 0) {
                    this.drawAuflagerStrich(auflagerGr, 'rotate(-90,'+AUFLAGERGRÖßE/2+',0)')
                    this.drawFedersteifigkeit(auflagerGr,'translate('+AUFLAGERGRÖßE/2+','+AUFLAGERGRÖßE/2+')')
                } 
                //x-Richtung Feder
                else if(auflager.Werte[0] > 0 && auflager.Werte[1] == -1){
                    this.drawFedersteifigkeit(auflagerGr,'rotate(-90) translate(0,'+AUFLAGERGRÖßE+')')
                    this.drawAuflagerFest(auflagerGr,'translate('+AUFLAGERGRÖßE*1.25+','+AUFLAGERGRÖßE/2+') rotate(-90)')
                }
                //x-Richtung und Y-Richtung Feder
                else if(auflager.Werte[0] > 0 && auflager.Werte[1] > 0){
                    this.drawFedersteifigkeit(auflagerGr,'rotate(-90) translate(0,'+AUFLAGERGRÖßE+')')
                    this.drawFedersteifigkeit(auflagerGr,'translate('+AUFLAGERGRÖßE/2+','+AUFLAGERGRÖßE/2+')')
                }
            break
        }
    }

    drawAuflagerreaktionen(Gruppe, Auflagerreaktion){
        const Resultierende = false
        if(Auflagerreaktion.Werte[0] != 0 || Auflagerreaktion.Werte[1] !=0 || Auflagerreaktion.Werte[2] !=0){

            let AuflagerreaktionSVG = Gruppe.append('g')
                .attr('id','Auflagerreaktion '+Auflagerreaktion.Knoten.name)
                .attr('transform', 'translate('+ this.MaßstabX(Auflagerreaktion.Knoten.x) +','+ this.MaßstabY(Auflagerreaktion.Knoten.y) +')')
                .attr('stroke-width', AUFLAGERREAKTIONSTRICHSTÄRKE)
                .attr('stroke',AUFLAGERREAKTIONFARBE)
                .attr('fill', AUFLAGERREAKTIONFARBE);

            if(Auflagerreaktion.Werte[0] !=0 || Auflagerreaktion.Werte[1] !=0){
                if (Resultierende){
                    const l = Math.sqrt(Auflagerreaktion.Werte[0]*Auflagerreaktion.Werte[0]+Auflagerreaktion.Werte[1]*Auflagerreaktion.Werte[1])
                    const ts = Auflagerreaktion.Werte[1]/l; const tc = Auflagerreaktion.Werte[0]/l;
                    let winkel = Math.acos(tc)*180/Math.PI
                    if (Auflagerreaktion.Werte[1] != 0) {
                        winkel = winkel*Math.sign(Auflagerreaktion.Werte[1])
                        winkel = winkel < 0 ? winkel + 360 : winkel
                    }
                    this.drawPfeil(AuflagerreaktionSVG, AUFLAGERREAKTIONGRÖßE, winkel, {x: -16, y: 0})
                    this.drawPfeilBeschriftung(AuflagerreaktionSVG, (l/this.resultSettings.KraftEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name, winkel, {x: -16, y: 0})
                }else{
                    // HIER FALLS DIE LAST NICHT ALS RESULTIERENDE GEZEICHNET WERDEN SOLL, ALSO 2 PFEILE 
                    if( Auflagerreaktion.Werte[0] != 0){
                        let winkel = 270+Math.sign(Auflagerreaktion.Werte[0])*90
                        let PfeilX = this.drawPfeil(AuflagerreaktionSVG, AUFLAGERREAKTIONGRÖßE, winkel, {x: -16, y: 0})
                        let PfeilXBeschr = this.drawPfeilBeschriftung(AuflagerreaktionSVG, (Math.abs(Auflagerreaktion.Werte[0])/this.resultSettings.KraftEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name, winkel, {x:-16,y:0})
                    }
                    if( Auflagerreaktion.Werte[1] != 0){
                        let winkel = Math.sign(Auflagerreaktion.Werte[1])*90
                        let PfeilY = this.drawPfeil(AuflagerreaktionSVG, AUFLAGERREAKTIONGRÖßE, winkel, {x: -16, y: 0})
                        let PfeilYBeschr = this.drawPfeilBeschriftung(AuflagerreaktionSVG, (Math.abs(Auflagerreaktion.Werte[1])/this.resultSettings.KraftEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name, winkel, {x:-16,y:0})
                    }
                }
            }
            if (Auflagerreaktion.Werte[2] !=0){
                let richtung = Math.sign(Auflagerreaktion.Werte[2])
                let MPfeil = this.drawMomentenPfeil(AuflagerreaktionSVG, AUFLAGERREAKTIONGRÖßE, richtung, {x: 0, y:0})
                let MPfeilBeschr = this.drawPfeilBeschriftung(AuflagerreaktionSVG, (Math.abs(Auflagerreaktion.Werte[2])/this.resultSettings.KraftEinheit.value*this.resultSettings.LängenEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name+this.resultSettings.LängenEinheit.name,0,{x:0,y:-12})

                // let M = AuflagerreaktionSVG.append('g')
                //     .attr('transform', 'scale('+Math.sign(Auflagerreaktion.Werte[2])+',1)' )

                // let arc = d3.arc()
                // .innerRadius(AUFLAGERREAKTIONGRÖßE/1.5)
                // .outerRadius(AUFLAGERREAKTIONGRÖßE/1.5)
                // .startAngle(-Math.PI/2)
                // .endAngle(Math.PI/2.5);
            
                //     M.append('path')
                //         .attrs({'d': arc,
                //             'fill': 'none',
                //             'stroke-width': AUFLAGERREAKTIONSTRICHSTÄRKE,
                //             'transform': 'rotate(0,0,0)'});

                //     M.append('polygon')
                //         .attrs({'points': [-AUFLAGERREAKTIONGRÖßE/6,-AUFLAGERREAKTIONGRÖßE/12,
                //                             0,0,
                //                             -AUFLAGERREAKTIONGRÖßE/6,AUFLAGERREAKTIONGRÖßE/12],
                //                 'stroke-width': AUFLAGERREAKTIONSTRICHSTÄRKE,
                //                 'transform': 'rotate(-18) translate('+AUFLAGERREAKTIONGRÖßE/1.5+','+AUFLAGERREAKTIONGRÖßE/6+') rotate(90)'
                //         })
            
                    // Beschriftung
                    // const transformString = 'translate('+this.MaßstabX(stab.center.x)+','+ this.MaßstabY(stab.center.y)+') rotate('+ -stab.vector.direction_deg+')'
                    // let text = strich.append('text')
                    //     .text('Stab Nr.'+stab.number)
                    //     .attrs({'font-family':'Calibri',
                    //         'font-size':'12px',
                    //         'stroke': 'none',
                    //         'dy': '-0.5ex',
                    //         'transform': transformString});
                    // text.attr('dx', -text._groups[0][0].getBBox().width/2)
            }
        }
    }

    drawKnotenlast(Gruppe, knotenlast){
        const Resultierende = true
        if(knotenlast.fX != 0 || knotenlast.fY !=0 || knotenlast.M !=0){
            let KnotenlastSVG = undefined
            const l = Math.sqrt(knotenlast.fX*knotenlast.fX+knotenlast.fY*knotenlast.fY)
            const ts = knotenlast.fY/l; const tc = knotenlast.fX/l;
            let winkel = Math.acos(tc)*180/Math.PI
            if (knotenlast.fY != 0) {
                winkel = winkel*Math.sign(knotenlast.fY)
                winkel = winkel < 0 ? winkel + 360 : winkel
            }
            knotenlast.Knotenliste.forEach(knoten=>{
                KnotenlastSVG = Gruppe.append('g')
                    .attr('id','Knotenlast_'+knotenlast.number)
                    .attr('transform', 'translate('+ this.MaßstabX(knoten.x) +','+ this.MaßstabY(knoten.y) +')')
                    .attr('stroke-width', KNOTENLASTSTRICHSTÄRKE)

                if(knotenlast.fX != 0 || knotenlast.fY !=0){
                    if (Resultierende){
                        this.drawPfeil(KnotenlastSVG, KNOTENLASTGRÖßE,winkel,{x:-8, y:0})
                        this.drawPfeilBeschriftung(KnotenlastSVG,(knotenlast.FRes/this.resultSettings.KraftEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name,winkel,{x:-8,y:0}, 'end')
                    }else{
                        // HIER FALLS DIE LAST NICHT ALS RESULTIERENDE GEZEICHNET WERDEN SOLL, ALSO 2 PFEILE 
                    }
                }
                if (knotenlast.M !=0){
                    let M = KnotenlastSVG.append('g')
                        .attr('transform', 'scale('+Math.sign(knotenlast.M)+',1)' )

                    let arc = d3.arc()
                    .innerRadius(KNOTENLASTGRÖßE/1.5)
                    .outerRadius(KNOTENLASTGRÖßE/1.5)
                    .startAngle(-Math.PI/2)
                    .endAngle(Math.PI/2.5);
                
                        M.append('path')
                            .attrs({'d': arc,
                                'fill': 'none',
                                // 'stroke-width': KNOTENLASTSTRICHSTÄRKE,
                                'transform': 'rotate(0,0,0)'});

                        M.append('polygon')
                            .attrs({'points': [-KNOTENLASTGRÖßE/6,-KNOTENLASTGRÖßE/12,
                                                0,0,
                                                -KNOTENLASTGRÖßE/6,KNOTENLASTGRÖßE/12],
                                    // 'stroke-width': KNOTENLASTSTRICHSTÄRKE,
                                    'transform': 'rotate(-18) translate('+KNOTENLASTGRÖßE/1.5+','+KNOTENLASTGRÖßE/6+') rotate(90)'
                            })
                }
                    // Beschriftung
                    // const transformString = 'translate('+this.MaßstabX(stab.center.x)+','+ this.MaßstabY(stab.center.y)+') rotate('+ -stab.vector.direction_deg+')'
                    // let text = strich.append('text')
                    //     .text('Stab Nr.'+stab.number)
                    //     .attrs({'font-family':'Calibri',
                    //         'font-size':'12px',
                    //         'stroke': 'none',
                    //         'dy': '-0.5ex',
                    //         'transform': transformString});
                    // text.attr('dx', -text._groups[0][0].getBBox().width/2)
                    KnotenlastSVG.on('contextmenu dblclick', function() {
                        d3.event.preventDefault()
                        store.commit('editKnotenlast',knotenlast)
                    })
                    .on('mouseover', function(){
                            d3.select(this).attr('stroke-width',KNOTENLASTSTRICHSTÄRKE*1.5)
                        })
                    .on('mouseout', function(){
                            d3.select(this).attr('stroke-width',KNOTENLASTSTRICHSTÄRKE)    
                    });
            })
        }
    }

    drawStablastGlobalStablänge(Gruppe, stablast){
        stablast.Stabliste.forEach(stab=>{
            const x = this.MaßstabX(stab.vector.x)-this.MaßstabX(0)
            const y = this.MaßstabY(stab.vector.y)-this.MaßstabY(0)
            const l = Math.sqrt(Math.pow(x,2)+Math.pow(y,2))
            const n = Math.trunc(l / STABLASTPFEILABSTAND)
            // const dl = l / n
            const dx = x/n //dl*stab.tcos
            const dy = y/n //dl*stab.tsin
                // ---Vertikal
               let StablastSVG1 = Gruppe.append('g')
                .attr('transform', 'translate('+ this.MaßstabX(stab.StartKnoten.x) +','+ (this.MaßstabY(stab.StartKnoten.y)-STABLASTOFSETY) +')')
                .on('contextmenu dblclick', function() {
                    d3.event.preventDefault()
                    store.commit('editStablast',stablast)
                })
                .on('mouseover', function(){
                        d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE*1.5)
                    })
                .on('mouseout', function(){
                        d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE)    
                });

                let max = Math.abs(stablast.p1)>Math.abs(stablast.p2) ? stablast.p1 : stablast.p2
                let maßstab = d3.scaleLinear().domain([0, max]).range([0, STABLASTGRÖßE]);
                //Umhüllungspolygon zeichnen
                StablastSVG1.append('polygon')
                    .attrs({'points': [0,0, 0,-maßstab(stablast.p1), x,y-maßstab(stablast.p2), x,y ],
                    'fill-opacity': 0.3});

                const dv = (stablast.p2-stablast.p1)/n
                for(let i = 0;i <= n; i++){
                    let cSTABLASTGRÖßE = maßstab(stablast.p1+i*dv)
                    StablastSVG1.append('polygon')
                    .attrs({'points': [0,-cSTABLASTGRÖßE,
                                    0,-cSTABLASTGRÖßE/6,
                                    cSTABLASTGRÖßE/12,-cSTABLASTGRÖßE/6,
                                    0,0,
                                    -cSTABLASTGRÖßE/12,-cSTABLASTGRÖßE/6,
                                    0,-cSTABLASTGRÖßE/6],
                            // 'stroke-width': STABLASTSTRICHSTÄRKE,
                            'transform': 'translate('+dx*i+','+dy*i+')'  
                    })
                }
                let labeltext1 = (stablast.p1/this.resultSettings.KraftEinheit.value*this.resultSettings.LängenEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name+'/'+this.resultSettings.LängenEinheit.name
                let labeltext2 = (stablast.p2/this.resultSettings.KraftEinheit.value*this.resultSettings.LängenEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name+'/'+this.resultSettings.LängenEinheit.name
                let Label1 = this.drawPfeilBeschriftung(StablastSVG1,labeltext1,-stab.vector.direction_deg,{x:stab.tsin*STABLASTGRÖßE,y:-STABLASTGRÖßE*stab.tcos}, 'start')
                let label2 = this.drawPfeilBeschriftung(StablastSVG1,labeltext2,-stab.vector.direction_deg,{x:x/stab.tcos+stab.tsin*STABLASTGRÖßE,y:-STABLASTGRÖßE*stab.tcos}, 'end')
        })
    }

    drawStablastGlobalProjektion(Gruppe, stablast){
        stablast.Stabliste.forEach(stab=>{
            const x = this.MaßstabX(stab.vector.x)-this.MaßstabX(0)
            const y = Math.sign(stab.vector.y)==1 ? this.MaßstabY(stab.vector.y)-this.MaßstabY(0) : 0
            const l = Math.sqrt(Math.pow(x,2)+Math.pow(y,2))
            const n = Math.trunc(l / STABLASTPFEILABSTAND)
            const dx = x/n //dl*stab.tcos
            const dy = 0 //dl*stab.tsin

                // ---Vertikal
                let StablastSVG1 = Gruppe.append('g')
                .attr('transform', 'translate('+ this.MaßstabX(stab.StartKnoten.x) +','+ (this.MaßstabY(stab.StartKnoten.y)-STABLASTOFSETY) +')')
                .on('contextmenu dblclick', function() {
                    d3.event.preventDefault()
                    store.commit('editStablast',stablast)
                })
                .on('mouseover', function(){
                        d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE*1.5)
                    })
                .on('mouseout', function(){
                        d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE)    
                });

                let max = Math.abs(stablast.p1)>Math.abs(stablast.p2) ? stablast.p1 : stablast.p2
                let maßstab = d3.scaleLinear().domain([0, max]).range([0, STABLASTGRÖßE]);
                //Umhüllungspolygon zeichnen        
                StablastSVG1.append('polygon')
                    .attrs({'points': [0,y, 0,y-maßstab(stablast.p1), x,y-maßstab(stablast.p2), x,y ],
                    'fill-opacity': 0.3});

                const dv = (stablast.p2-stablast.p1)/n
                for(let i = 0;i <= n; i++){
                    let cSTABLASTGRÖßE = maßstab(stablast.p1+i*dv)
                    StablastSVG1.append('polygon')
                    .attrs({'points': [0,y-cSTABLASTGRÖßE,
                                    0,y-cSTABLASTGRÖßE/6,
                                    cSTABLASTGRÖßE/12,y-cSTABLASTGRÖßE/6,
                                    0,y,
                                    -cSTABLASTGRÖßE/12,y-cSTABLASTGRÖßE/6,
                                    0,y-cSTABLASTGRÖßE/6],
                            // 'stroke-width': STABLASTSTRICHSTÄRKE,
                            'transform': 'translate('+dx*i+','+dy*i+')'  
                    })
                }
                let labeltext1 = (stablast.p1/this.resultSettings.KraftEinheit.value*this.resultSettings.LängenEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name+'/'+this.resultSettings.LängenEinheit.name
                let labeltext2 = (stablast.p2/this.resultSettings.KraftEinheit.value*this.resultSettings.LängenEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name+'/'+this.resultSettings.LängenEinheit.name
                let Label1 = this.drawPfeilBeschriftung(StablastSVG1,labeltext1,0,{x:0,y:y-maßstab(stablast.p1)},'start')
                let label2 = this.drawPfeilBeschriftung(StablastSVG1,labeltext2,0,{x:x,y:y-maßstab(stablast.p2)},'end')
        })
    }

    drawStablastLocalStablänge(Gruppe, stablast){
        stablast.Stabliste.forEach(stab=>{
            const x = this.MaßstabX(stab.vector.x)-this.MaßstabX(0)
            const y = this.MaßstabY(stab.vector.y)-this.MaßstabY(0)
            const l = Math.sqrt(Math.pow(x,2)+Math.pow(y,2))
            const n = Math.trunc(l / STABLASTPFEILABSTAND)
            const dx = x/n //dl*stab.tcos
            const dy = y/n //dl*stab.tsin

                // ---Lokal senkrecht auf Stab
                let StablastSVG1 = Gruppe.append('g')
                .attr('transform', 'translate('+ (this.MaßstabX(stab.StartKnoten.x)-STABLASTOFSETY*stab.tsin) +','+ (this.MaßstabY(stab.StartKnoten.y)-STABLASTOFSETY*stab.tcos) +')')
                .on('contextmenu dblclick', function() {
                    d3.event.preventDefault()
                    store.commit('editStablast',stablast)
                })
                .on('mouseover', function(){
                        d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE*1.5)
                    })
                .on('mouseout', function(){
                        d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE)    
                });

                let max = Math.abs(stablast.p1)>Math.abs(stablast.p2) ? stablast.p1 : stablast.p2
                let maßstab = d3.scaleLinear().domain([0, max]).range([0, STABLASTGRÖßE]);
                
                //Umhüllungspolygon zeichnen
                StablastSVG1.append('polygon')
                    .attrs({'points': [0,0, -maßstab(stablast.p1)*stab.tsin,-maßstab(stablast.p1)*stab.tcos, x-maßstab(stablast.p2)*stab.tsin,y-maßstab(stablast.p2)*stab.tcos, x,y ],
                    'fill-opacity': 0.3});

                const dv = (stablast.p2-stablast.p1)/n
                for(let i = 0;i <= n; i++){
                    let cSTABLASTGRÖßE = maßstab(stablast.p1+i*dv)
                    StablastSVG1.append('polygon')
                    .attrs({'points': [0,-cSTABLASTGRÖßE,
                                        0,-cSTABLASTGRÖßE/6,
                                        cSTABLASTGRÖßE/12,-cSTABLASTGRÖßE/6,
                                        0,0,
                                        -cSTABLASTGRÖßE/12,-cSTABLASTGRÖßE/6,
                                        0,-cSTABLASTGRÖßE/6],
                            // 'stroke-width': STABLASTSTRICHSTÄRKE,
                            'transform': 'translate('+dx*i+','+dy*i+') rotate('+(-stab.vector.direction_deg)+')'  
                    })
                }

                let labeltext1 = (stablast.p1/this.resultSettings.KraftEinheit.value*this.resultSettings.LängenEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name+'/'+this.resultSettings.LängenEinheit.name
                let labeltext2 = (stablast.p2/this.resultSettings.KraftEinheit.value*this.resultSettings.LängenEinheit.value).toFixed(2)+this.resultSettings.KraftEinheit.name+'/'+this.resultSettings.LängenEinheit.name
                let Label1 = this.drawPfeilBeschriftung(StablastSVG1,labeltext1,0,{x:0,y:-maßstab(stablast.p1)})
                let label2 = this.drawPfeilBeschriftung(StablastSVG1,labeltext2,0,{x:x,y:y-maßstab(stablast.p2)})
        })
    }

    drawStablast(Gruppe, stablast){
        // Global auf Stablänge; Fall für Eigenlasten
        if (stablast.Orientierung == 0 && stablast.Bezugslänge == 0){
            this.drawStablastGlobalStablänge(Gruppe, stablast)
        } 
        // Global auf Projektion; Fall für Schneelasten
        else if(stablast.Orientierung == 0 && stablast.Bezugslänge == 1){
            this.drawStablastGlobalProjektion(Gruppe, stablast)
        }
        // Lokal auf Stablänge; Fall für Windlasten
        else if(stablast.Orientierung == 1 && stablast.Bezugslänge == 0){
            this.drawStablastLocalStablänge(Gruppe, stablast)
        }   
    }

    drawStabschnittkräfte(Gruppe, stab, Stabschnittkräfte, typ, MaxWerte){
        if (Stabschnittkräfte){
            const Faktor = typ == 'M' ? this.resultSettings.LängenEinheit.value/this.resultSettings.KraftEinheit.value : 1/this.resultSettings.KraftEinheit.value
            const x = this.MaßstabX(stab.vector.x)-this.MaßstabX(0)
            const y = this.MaßstabY(stab.vector.y)-this.MaßstabY(0)
            const l = Math.sqrt(Math.pow(x,2)+Math.pow(y,2))
            const n = Stabschnittkräfte.length-1
    
            const dl = l/n //dl*stab.tcos
            let curSVG = Gruppe.append('g')
            .attr('transform', 'translate('+ this.MaßstabX(stab.StartKnoten.x) +','+ (this.MaßstabY(stab.StartKnoten.y)) +')')
            // .on('contextmenu', function() {
            //     d3.event.preventDefault()
            //     store.commit('editSchnittkraftSkalierung')
            // })
            // .on('mouseover', function(){
            //         d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE*1.5)
            //     })
            // .on('mouseout', function(){
            //         d3.select(this).attr('stroke-width',STABLASTSTRICHSTÄRKE)    
            // });

            // let max = getMax(Stabschnittkräfte)
            // let min = getMin(Stabschnittkräfte)
            let maßgebend = {index: 0, value: 0}

            Stabschnittkräfte.forEach((val,index) =>{
                if (Math.abs(val) > maßgebend.value){
                    maßgebend.value = Math.abs(val)
                    maßgebend.index = index
                }
            })

            // Der Wert MaxWerte gibt den maximalen Wert für den Lastfall an, dieser kann auch an einem anderen Stab auftreten und wird gebraucht um die Schnittkräfte richtig zu skalieren.
            // Der Wert maßgebend gibt den maximalen Wert für den betrachteten Stab wieder.
            let maßstab = d3.scaleLinear().domain([0, MaxWerte]).range([0, SCHNITTKRAFTGRÖßE])

            //Umhüllungspolygon zeichnen
            let polyPoints = [0,0]
            if (!(maßgebend.value == 0)){
                Stabschnittkräfte.forEach((value,index)=>{
                    polyPoints.push(dl*index)
                    polyPoints.push(maßstab(value))
                })
                polyPoints.push(l,0,0,0)

                let curGruppe = curSVG.append('g').attrs({
                    x: 0,
                    y: -maßstab(maßgebend.value),
                    width: l,
                    height: 2*maßstab(maßgebend.value),
                    'stroke': 'url(#SchnittkraftFarbe)',
                    'fill': 'url(#SchnittkraftFarbe)',
                    transform: 'rotate('+(-stab.vector.direction_deg)+')'
                });
                curGruppe.append('polygon').attrs({
                        'points': polyPoints,
                        'fill-opacity': 0.3,
                    });
                
                Stabschnittkräfte.forEach((value,index)=>{
                    curGruppe.append('circle')
                        .attr('r', 2)
                        .attr('cx', dl*index)
                        .attr('cy', maßstab(value));

                    const textOffset = Math.sign(value) == 1 ? 15 : -5 

                    curGruppe.append('text')
                        .text((Faktor*value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}))
                        .attr('stroke', 'none')
                        .attr('text-anchor', 'middle')
                        .attr('font-size', 10)
                        .attr('x',dl*index)
                        .attr('y', maßstab(value))
                        .attr('dy', textOffset)
                })

                // const TextStr = maßgebend.value*Faktor
                // let text = curGruppe.append('text')
                //     .text(TextStr.toFixed(2))
                //     .attrs({'font-family':'Calibri',
                //         'font-size':'12px',
                //         'stroke': 'black',
                //         x: maßgebend.index*dl,
                //         y: maßstab(maßgebend.value)
                //         });
                // text.attr('dx', -text._groups[0][0].getBBox().width/2)
            }
        }
    }

    drawVerformung(Gruppe, stab, Verformungen, MaxWerte){
        if (Verformungen){
            const x = this.MaßstabX(stab.vector.x)-this.MaßstabX(0)
            const y = this.MaßstabY(stab.vector.y)-this.MaßstabY(0)
            const l = Math.sqrt(Math.pow(x,2)+Math.pow(y,2))
            const n = Verformungen.length-1

            const dl = l/n //dl*stab.tcos
            let curSVG = Gruppe.append('g')
            .attr('transform', 'translate('+ this.MaßstabX(stab.StartKnoten.x) +','+ (this.MaßstabY(stab.StartKnoten.y)) +')')

            let maßgebend = {index: 0, value: 0}

            Verformungen.forEach((val,index) =>{
                if (Math.abs(val) > maßgebend.value){
                    maßgebend.value = Math.abs(val)
                    maßgebend.index = index
                }
            })

            // Der Wert MaxWerte gibt den maximalen Wert für den Lastfall an, dieser kann auch an einem anderen Stab auftreten und wird gebraucht um die Schnittkräfte richtig zu skalieren.
            // Der Wert maßgebend gibt den maximalen Wert für den betrachteten Stab wieder.
            let maßstab = d3.scaleLinear().domain([0, MaxWerte]).range([0, SCHNITTKRAFTGRÖßE])

            //Umhüllungspolygon zeichnen
            let polyPoints = []

                Verformungen.forEach((value,index)=>{
                    polyPoints.push([dl*index+maßstab(value[0]),maßstab(value[1])])
                })

                let curGruppe = curSVG.append('g').attrs({
                    transform: 'rotate('+(-stab.vector.direction_deg)+')'
                });
                curGruppe.append('polyline').attrs({
                        'points': polyPoints,
                        'fill': 'none'
                        // 'fill-opacity': 0.3,
                    });
               
                Verformungen.forEach((value,index)=>{
                    const id = 'tS'+ stab.number + 'I' + index
                    const textOffset = 15 //Math.sign(value) == 1 ? 15 : -5 

                    curGruppe.append('text')
                        .text((value[0]*1000).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1})+ '; ' + (value[1]*1000).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1}))
                        .attr('id', id)
                        .attr('stroke', 'none')
                        .attr('text-anchor', 'middle')
                        .attr('font-size', 10)
                        .attr('visibility', 'hidden')
                        .attr('x',dl*index+maßstab(value[0]))
                        .attr('y', maßstab(value[1]))
                        .attr('dy', textOffset);

                    curGruppe.append('circle')
                        .attr('r', 8)
                        .attr('cx', dl*index+maßstab(value[0]))
                        .attr('cy', maßstab(value[1]))
                        .attr('stroke', 'none')
                        .attr('fill-opacity', '0')
                        .on('click', function(){
                            d3.event.preventDefault();
                            let visBoolean = d3.select('#'+id).attr('visibility')
                            d3.select('#'+id).attr('visibility', visBoolean == 'visible' ? 'hidden' : 'visible')
                        });
                    curGruppe.append('ellipse')
                        .attr('rx', 0.1)
                        .attr('ry', 2)
                        .attr('cx', dl*index+maßstab(value[0]))
                        .attr('cy', maßstab(value[1]));
                            
                })
        }
    }

    setMaßstab(box){
        const cw = box.width/(this.width-2*RAND)
        const ch = box.height/(this.height-2*RAND)
        if(cw > ch){
            this.MaßstabX = d3.scaleLinear()
                .domain([box.left, box.right])
                .range([RAND, this.width-RAND]);
            const delta = this.height-2*RAND-box.height/cw
            this.MaßstabY = d3.scaleLinear()
                .domain([box.top, box.bottom])
                .range([RAND+delta/2, this.height-RAND-delta/2]);
        }else {
            this.MaßstabY = d3.scaleLinear()
                .domain([box.top, box.bottom])
                .range([RAND, this.height-RAND]);
            const delta = this.width-2*RAND-box.width/ch
            this.MaßstabX = d3.scaleLinear()
                .domain([box.left, box.right])
                .range([RAND+delta/2, this.width-RAND-delta/2]);
        }
        console.log('MaßstabX 1:',this.MaßstabX(1))
        console.log('MaßstabY 1:',this.MaßstabY(1))  
    }

    drawRaster(){
        // Add scales to axis
        var x_axis = d3.axisTop()
            .scale(this.MaßstabX);
        var y_axis = d3.axisRight()
            .scale(this.MaßstabY);

        //Append group and insert axis
        let achsen = this.canvas.append('g').attr('id', 'Achsen')
            achsen.append('g')
            .attr("transform", "translate(0, " + (this.height-5) +")")
            .call(x_axis);
            achsen.append('g')
            .attr("transform", "translate(5, 0)")
            .call(y_axis);
    }

    drawSystem(StatikSystem, drawOptions){
        this.clear()
        StatikSystem.setSize()
            .then(box => this.setMaßstab(box))
            .then(()=>{
                let lastfall = drawOptions.Lastfall != undefined ? drawOptions.Lastfall : null
                this.drawRaster()
                // '--- Schnittkräfte Zeichnen wegen Z-Order muss das der erste Schritt sein.
                if(lastfall && lastfall.Berechnet){
                    let SchnittkräfteGruppe = this.canvas.append('g')
                    .attr('id', 'Schnittkräfte').attr('stroke', 'black');
                    let NormalkraftSVG = SchnittkräfteGruppe.append('g').attr('id', 'Normalkräfte').attr('visibility','hidden');
                    let QuerkraftSVG = SchnittkräfteGruppe.append('g').attr('id', 'Querkräfte').attr('visibility','hidden');
                    let MomentenSVG = SchnittkräfteGruppe.append('g').attr('id', 'Momente').attr('visibility','hidden');
                    let VerformungsSVG = SchnittkräfteGruppe.append('g').attr('id', 'Verformungen').attr('visibility','visible');
                    lastfall.Schnittkräfte.forEach(Schnittkräfte =>{
                        if (!drawOptions.HiddenElements.some(stab => stab === Schnittkräfte.Stab)){
                            this.drawStabschnittkräfte(NormalkraftSVG, Schnittkräfte.Stab, Schnittkräfte.N,'N', lastfall.MaxWerte.N)
                            this.drawStabschnittkräfte(QuerkraftSVG, Schnittkräfte.Stab, Schnittkräfte.Q,'Q', lastfall.MaxWerte.Q)
                            this.drawStabschnittkräfte(MomentenSVG, Schnittkräfte.Stab, Schnittkräfte.M,'M', lastfall.MaxWerte.M)
                            this.drawVerformung(VerformungsSVG, Schnittkräfte.Stab, Schnittkräfte.W, lastfall.MaxWerte.W)   
                        }   
                    })
                }

                // Stäbe Zeichnen (incl. Gelenke)
                let StabGrp = this.canvas.append('g').attr('id', 'Stäbe');
                StatikSystem.Stabliste.forEach(stab =>{
                    if (!drawOptions.HiddenElements.some(hidestab => hidestab === stab)){
                    this.drawStab(StabGrp, stab)
                    }
                }) 
                
                // Knoten Zeichnen (incl. Auflager)
                let KnotenGrp = this.canvas.append('g').attr('id', 'Knoten');
                StatikSystem.Knotenliste.forEach(knoten =>{
                    let KnotenGruppe = KnotenGrp.append('g').attr('class', 'Knoten');
                    this.drawKnoten(KnotenGruppe, knoten)
                })

                // Lastfall Zeichnen
                let BelastungGrp = this.canvas.append('g').attr('id', 'Belastung');
                if (lastfall){
                    let LastfallGruppe = BelastungGrp.append('g')
                        .attr('id', 'Lastfall: '+ lastfall.Name)
                        .attr('stroke', lastfall.Color)
                        .attr('fill', lastfall.Color);
                    lastfall.Knotenlastliste.forEach(knotenlast =>{
                        this.drawKnotenlast(LastfallGruppe, knotenlast)
                    })
                    lastfall.Stablastliste.forEach(stablast =>{
                        this.drawStablast(LastfallGruppe, stablast)
                    })
                }
                                 
                // '--- Auflagerreaktionen Zeichnen
                // if (drawOptions.drawAuflagerreaktionen){
                    if(lastfall && lastfall.Berechnet){
                        let AuflagerreaktionenGruppe = this.canvas.append('g').attr('id', 'Auflagerreaktionen').attr('visibility','visible');
                        lastfall.Auflagerreaktionen.forEach(Auflager =>{
                            this.drawAuflagerreaktionen(AuflagerreaktionenGruppe, Auflager)
                        })
                    }
                // }


                //     If cCanvas.Drawing_Flaggs And DRAW_ERGEBNISSE Then
                //         If cLastfall.Berechnet Then
                //         Dim strEinheit(1 To 2) As String
                //             For Each curStab In mSys.Stabliste.ToArray
                //                 curStab.draw_Schnittkraft cCanvas, cLastfall, cCanvas.Drawing_Schnittkrafttyp_Flaggs
                //             Next curStab
                //         draw_Info cCanvas, cCanvas.Drawing_Schnittkrafttyp_Flaggs
                //         End If
                //     End If
                // End If
            })
            // FEHLERMELDUNG FALLS KEINE KNOTEN VORHANDEN
            .catch(err=>{
                this.canvas.append('g').attr('id', 'Knoten')
                .append('text')
                .text(err.message)
                .attrs({'font-family':'Calibri',
                    'font-size':'20px',
                    'stroke': 'none',
                    'dy': '2ex',
                    'dx': '2ex'});
                console.log(err.message)
            })
    }

    changeSchnittkraftVisibility(Schnittkraft){
        let schnittkraftGruppe = this.canvas.selectAll('svg > #Schnittkräfte')
        schnittkraftGruppe.selectAll('#Normalkräfte, #Querkräfte, #Momente, #Verformungen').attr('visibility', 'hidden')
        if (Schnittkraft) schnittkraftGruppe.selectAll('#'+Schnittkraft).attr('visibility', 'visible')
    }

    changeBelastungVisibility(val){
        const str = val ? 'visible' : 'hidden'
        let grp = this.canvas.selectAll('svg > #Belastung').attr('visibility', str)
    }
    changeAuflagerkraftVisibility(val){
        const str = val ? 'visible' : 'hidden'
        let grp = this.canvas.selectAll('svg > #Auflagerreaktionen').attr('visibility', str)
    }
}
